import React from "react";
import { Navigate } from "react-router";
import { useAuth } from "../../context/AuthContext";

/**
 * PublicRoute component that redirects authenticated users away from
 * public routes like login and OTP verification
 */
const PublicRoute = ({ children }) => {
  const { user } = useAuth();

  // If user is authenticated, redirect to root (token-only auth)
  if (user) {
    return <Navigate to="/" replace />;
  }

  // If not authenticated, show the requested public route
  return children;
};

export default PublicRoute;
